declare namespace $ {

	type __shm_hitalama_quick2_reorder_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_quick2_reorder['order_dragged'] >[0]
		,
		Parameters< $shm_hitalama_quick2_reorder['Drag'] >[0]
	>
	type $mol_view__style_shm_hitalama_quick2_reorder_2 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_hitalama_quick2_reorder['panel_width'] >,
			'height': ReturnType< $shm_hitalama_quick2_reorder['panel_height'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_quick2_reorder_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['buttons'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__checked_shm_hitalama_quick2_reorder_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['button_checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__event_shm_hitalama_quick2_reorder_5 = $mol_type_enforce<
		({ 
			pointerenter( next?: ReturnType< $shm_hitalama_quick2_reorder['pointerenter'] > ): ReturnType< $shm_hitalama_quick2_reorder['pointerenter'] >,
			pointerleave( next?: ReturnType< $shm_hitalama_quick2_reorder['pointerleave'] > ): ReturnType< $shm_hitalama_quick2_reorder['pointerleave'] >,
		})  & ReturnType< $mol_check['event'] >
		,
		ReturnType< $mol_check['event'] >
	>
	type $mol_check__sub_shm_hitalama_quick2_reorder_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $shm_hitalama_quick_item__left_shm_hitalama_quick2_reorder_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['drag_x'] >
		,
		ReturnType< $shm_hitalama_quick_item['left'] >
	>
	type $shm_hitalama_quick_item__top_shm_hitalama_quick2_reorder_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['drag_y'] >
		,
		ReturnType< $shm_hitalama_quick_item['top'] >
	>
	type $shm_hitalama_quick_item__on_drag_start_shm_hitalama_quick2_reorder_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['order_start'] >
		,
		ReturnType< $shm_hitalama_quick_item['on_drag_start'] >
	>
	type $shm_hitalama_quick_item__on_drag_end_shm_hitalama_quick2_reorder_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_quick2_reorder['order_end'] >
		,
		ReturnType< $shm_hitalama_quick_item['on_drag_end'] >
	>
	type $shm_hitalama_quick_item__sub_shm_hitalama_quick2_reorder_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_quick_item['sub'] >
	>
	export class $shm_hitalama_quick2_reorder extends $shm_hitalama_quick2 {
		panel_width( ): string
		panel_height( ): string
		buttons( ): readonly(any)[]
		button_checked( id: any, next?: boolean ): boolean
		drag_x( id: any, next?: number ): number
		drag_y( id: any, next?: number ): number
		order_dragged( id: any): ReturnType< ReturnType< $shm_hitalama_quick2_reorder['Drag'] >['dragged'] >
		order_start( id: any, next?: any ): any
		order_end( id: any, next?: any ): any
		ids( next?: readonly(string)[] ): readonly(string)[]
		gesture_moved( id: any, next?: boolean ): boolean
		Panel( ): $mol_view
		Button( id: any): $mol_check
		Drag( id: any): $shm_hitalama_quick_item
	}
	
}

//# sourceMappingURL=reorder.view.tree.d.ts.map